/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formfields_Dropdown_Placeholder1Inputs */

const en_formfields_dropdown_placeholder1 = /** @type {(inputs: Formfields_Dropdown_Placeholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select an option`)
};

/**
* | output |
* | --- |
* | "Select an option" |
*
* @param {Formfields_Dropdown_Placeholder1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const formfields_dropdown_placeholder1 = /** @type {((inputs?: Formfields_Dropdown_Placeholder1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formfields_Dropdown_Placeholder1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_formfields_dropdown_placeholder1(inputs)
});
export { formfields_dropdown_placeholder1 as "formFields_dropdown_placeholder" }